import { useEffect, useState } from "react";
import { rtctApi } from "services/rtctApi";
import { readSoil } from "utils/soilSurface";
import { useStableState } from "utils/stableState";

// The estimated soil surface (radar/soil/), asked for only while the viewer has it switched on. The switch is
// remembered in this browser (a convenience: it decides nothing).
const KEY = "field_soil_line";

function remembered() {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function useSoilSurface(mac, days = 7) {
  const [on, setOn] = useState(remembered);
  const [state, setState] = useStableState({ key: "", soil: null, error: "" });
  const key = `${mac}|${days}`;
  useEffect(() => {
    try {
      window.localStorage.setItem(KEY, on ? "1" : "0");
    } catch {
      // private window: the switch just is not remembered
    }
  }, [on]);
  useEffect(() => {
    if (!on || !mac || typeof rtctApi.radarSoil !== "function") return undefined;
    const abort = new AbortController();
    Promise.resolve(rtctApi.radarSoil(mac, abort.signal, { days }))
      .then((data) => {
        if (!abort.signal.aborted) setState({ key, soil: readSoil(data), error: "" });
      })
      .catch((e) => {
        if (!abort.signal.aborted) setState({ key, soil: null, error: e?.message || "Soil surface estimate unavailable" });
      });
    return () => abort.abort();
  }, [on, mac, days, key, setState]);
  const mine = state.key === key;
  return {
    on,
    setOn,
    available: typeof rtctApi.radarSoil === "function",
    soil: on && mine ? state.soil : null,
    error: on && mine ? state.error : "",
    loading: on && !mine,
  };
}
